"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VWOAnalyticsService = void 0;
const config_1 = require("../../utils/helpers/config");
exports.VWOAnalyticsService = {
    dispatchVWOEvent: (eventName, properties) => {
        window.VWO = window.VWO || [];
        window.VWO.event =
            window.VWO.event ||
                function () {
                    // eslint-disable-next-line prefer-rest-params
                    window.VWO.push(['event'].concat([].slice.call(arguments)));
                };
        if (config_1.appConfig.isDevelopment) {
            console.log(`VWOEvents: Disparando evento ${eventName}`, properties);
        }
        window.VWO.event(eventName, properties);
    },
    /**
     * O método `dispatchVWOEventBefore` retorna uma nova função de callback
     * que executa o disparo de um evento para o VWO antes de executar
     * o callback passado como parâmetro.
     *
     * @param vwoEvent Nome do Evento do VWO
     * @param callback Callback a ser executado após o disparo do Evento do VWO
     * @returns
     */
    dispatchVWOEventBefore(vwoEvent, callback) {
        return function () {
            try {
                exports.VWOAnalyticsService.dispatchVWOEvent(vwoEvent);
            }
            catch (err) {
                console.warn(`Não foi possível disparar o evento ${vwoEvent} ao VWO.`);
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return callback(...arguments);
        };
    },
};
